<!-- <app-breadcrumb [pageName]="'Specification'"></app-breadcrumb> -->
<main>
	<!-- design area start -->
	<div class="container mt-5">
		<div class="ck-content table_responsive_css_addon" [innerHTML]="data|safeHtml"></div>
	</div>
	<!-- design area end -->
</main>